/* ============================================================
   TRITON · POSEIDON — single content/config source
   This object is the externalized content layer. On the Shopify
   (Prestige) integrate path, Liquid injects these same values into
   the matching sections, so copy/price/links live in ONE place.

   confirmed.* = the pre-build honesty gate. false means the claim
   is NOT yet verified by Gabi and is shown as a marked placeholder
   (see app.js gating). Flip to true only after Gabi confirms.
   ============================================================ */
window.TRITON_DATA = {
  brand: 'TRITON',
  product: 'POSEIDON',
  slogan: 'קו נקי. מסגרת שמדברת בשבילך.',

  price: { now: 349, was: 499, currency: '₪' },

  whatsapp: {
    number: '972544684517', // 054-468-4517 -> confirm with Gabi
    message: 'היי, אפשר פרטים על POSEIDON?',
  },
  storeUrl: 'https://triton.style',
  email: 'info@triton.style',
  social: {
    instagram: 'https://instagram.com/triton.israel',
    tiktok: '', // URL pending from Gabi
  },

  specs: {
    motor: 'BLDC',
    rpm: 7200,
    blade: 'DLC',
    battery: '2000mAh',
    runtimeH: 3.5,
    weightG: 167,
    charge: 'USB-C + עגינה מגנטית',
  },

  // demo: a big Add-to-Cart button whose action is WhatsApp + a small store link.
  // integrate: switch to 'cart' to use the native Shopify add-to-cart.
  buyMode: 'cart',

  // === PRE-BUILD HONESTY GATE (confirm with Gabi before these print as fact) ===
  confirmed: {
    runtime: false,          // 3.5h figure
    wasPrice: true,          // ₪499 prior price (confirmed by Avi 2026-06-30)
    warranty: false,         // length + terms
    madeInIsrael: false,     // assembled vs branded
    cod: false,              // cash on delivery offered?
    whatsappNumber: false,   // live business number
    barberEndorsement: false,// any real endorsement / testimonials
    tiktok: false,           // active account URL
  },
};
